import React from 'react';
import { Box, Button, SvgIconProps, useTheme } from '@mui/material';
import { CSVLink } from 'react-csv';

interface DownloadButtonProps {
  data: string | string[][] | Array<{ [key: string]: string }>;
  text?: string;
  icon?: React.ReactElement<SvgIconProps>;
  disabled?: boolean;
}

const DownloadButton: React.FC<DownloadButtonProps> = ({
  data,
  text,
  icon,
  disabled,
}) => {
  const theme = useTheme();

  return (
    <Button
      color="primary"
      variant="outlined"
      sx={{ mt: 2 }}
      disabled={disabled}
    >
      <CSVLink
        data={data}
        target="_blank"
        filename="TemplateRoomFeatureFilters.csv"
        style={{
          color: disabled
            ? theme.palette.grey[500]
            : theme.palette.primary.main,
          textDecoration: 'none',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
          }}
        >
          {text ?? 'Download CSV'} {icon && icon}
        </Box>
      </CSVLink>
    </Button>
  );
};

export default React.memo(DownloadButton);
